<template>
    <el-drawer :title="formData.id ? '编辑立减活动' :'创建立减活动' " :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="auto"
        @close="close">
            <div class="drawer-content"> 
				<el-form
				    :model="formData"				    
				    ref="formData"
				    label-position="top"
				    v-loading="dataLoading"
				>
                    <el-form-item prop="name"  :rules="[{ required: true, message: '请填写活动名称' }]">
                        <span slot="label">活动名称：</span>
                        <el-input v-model="formData.name" maxlength="24"></el-input>
                    </el-form-item>					
					<el-form-item label="活动可用类型/演出">
						<el-select v-model="type" placeholder="请选择" size="small" @change="typeChange">
						    <el-option label="活动类型" :value="1"></el-option>
						    <el-option label="演出ID" :value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="showTypeTagIds" label="可用活动类型：" :rules="[{ required: true, message: '请选择可用活动类型' }]" v-if="type == 1">
					    <el-cascader v-model="formData.showTypeTagIds" collapse-tags :options="showTypeTagList"
					        :props="{multiple: true, value: 'id', label: 'name', children: 'tags', emitPath:false }" clearable placeholder="不限制活动类型"  style="width:100%" ref="cascader">
					    </el-cascader>
					</el-form-item>
					<el-form-item  label="可用活动演出：" v-if="type == 2">
					    <span slot="label">可用活动演出：<small class="from-tip"><span class="el-icon-warning"></span>填写演出ID，多个ID之间用逗号分隔，不填视为所有演出通用</small></span>
					    <el-input placeholder="请输入演出ID" v-model="activityIds">
					        <el-button slot="append" icon="el-icon-search" @click="searchActivity()">添加演出</el-button>
					    </el-input>
					    <el-table class="MT10 sortable-table" :data="sActivityList" size="mini" border stripe v-loading="sActivityLoading" row-key="id">					        
					        <el-table-column prop="id" label="演出ID" width="90"></el-table-column>
					        <el-table-column prop="name" label="演出名称" show-overflow-tooltip></el-table-column>					        
					        <el-table-column label="操作" width="80">
					            <template slot-scope="scope">
					                <el-button type="text" @click="delActivity(scope.row.id)">删除</el-button>
					            </template>
					        </el-table-column>
					    </el-table>
					</el-form-item>
					<el-form-item prop="datetimerange" :rules="[{ required: true, message: '请选择活动有效期' }]">
					    <span slot="label">活动有效期：</span>					   
					        <el-date-picker
					            v-model="formData.datetimerange"
					            type="datetimerange"
					            start-placeholder="开始时间"
					            end-placeholder="结束时间"
					            value-format="yyyy-MM-dd HH:mm:ss"
					            size="medium"
					            unlink-panels
					        ></el-date-picker>					    
					</el-form-item>
					<el-form-item prop="serviceFeeRateView" label="立减票提上限："  :rules="[{ required: true, message: '请填写立减票提上限' }]">
					    <el-input-number style="width:95%" v-model="formData.serviceFeeRateView" :precision="0"
					        controls-position="right" :min="1" :max="100" size="medium"
					        placeholder="请填写立减票提上限"></el-input-number> %
					</el-form-item>                 
                </el-form>
            </div>
            <div class="drawer-footer">
                <el-button @click="close">关闭</el-button>
                <el-button type="primary" :loading="btnLoading" @click="submitForm()"
                >确认</el-button
            >
            </div>
    </el-drawer>
</template>
<script>

const defaultFormData = {
	id:'',
	name:'',
	startTime:'',
	endTime:'',
	serviceFeeRateView:'',
	showTypeTagIds:'',
	datetimerange:[],
	activityIds:''
}
export default {
    data(){
        return{
            drawerShow:false,
            btnLoading:false,
            formData:{...defaultFormData},           
            dataLoading: false,			
			showTypeTagList: [],
			data:{},
			activityIds: "",
			sActivityLoading: false,
			sActivityList: [],
			type:1
        }
    },
    methods:{
        show(data){			
			this.formData = data ? {
			    ...defaultFormData,
			    ...data,
			    datetimerange:[data.startTime,data.endTime],
				showTypeTagIds: data && data.showTypeTagIds ? data.showTypeTagIds.split(',') : []  
				
			} 
			: {...defaultFormData};
			if( data && data.id ){
				this.type = data.activityIds ? 2 : 1 ;				
				if (data.activityIds) {
					this.activityIds = data.activityIds.toString();
				    this.searchActivity(() => {
				        this.$nextTick(() => {
				            
				        })
				    });
				}
			}
            this.drawerShow = true;
			this.getShowTypeTag();	
        },		
        close(){
            this.formData = {...defaultFormData};           
            this.drawerShow = false;
			this.activityIds = ''
			this.sActivityList = []
			this.showTypeTagList = []
        },
		typeChange(value){
			if( value == 1 ){
				this.formData.activityIds = ''
			}else{
				this.formData.showTypeTagIds = ''
			}
		},
        //获取活动类型
        getShowTypeTag() {
            this.$request({
                url: "/styleTag/showType/all",
                method: "post",
                params: { isAll: 1 }
            }).then(res => {
                const { state, result } = res.data;
                if (state == 1) {
                    this.showTypeTagList = result || []
                }
            })
        },
       //搜索演出
       async searchActivity(callback) {
           if (this.activityIds) {
               this.sActivityLoading = true;
       
               this.activityIds = this.activityIds.replace(/，/g, ',');
       
               let _activityIds = this.activityIds.split(',');
               _activityIds.map((v, i) => _activityIds[i] = parseInt(v));
       
               const res = await this.$request({
                   url: '/activity/activityIdNameList',
                   method: 'post',
                   data: _activityIds
               }).catch(() => {
                   return { data: { state: '0', msg: '请求错误' } };
               }).finally(() => {
                   this.sActivityLoading = false;
               });
       
               const { state, msg, result } = res.data;
       
               if (state != 1) {
                   return this.$message.error(msg || '请求失败');
       
               } else {
                   if (result && result.length > 0) {
       
                       result.map(item => {
                           if (!this.sActivityList.find(v => v.id == item.id)) {
                               this.sActivityList.push(item)
                           }
                       })
                       
                       callback && callback();
       
                   } else {
                       this.$message.error(msg || '没有找到相关演出');
                   }
               }
           }
       },
       //删除演出
       delActivity(id) {
           this.sActivityList = this.sActivityList.filter(v => v.id != id);
       },
	  
        //表单提交
        submitForm(){
			if( this.type == 1 ){
				this.activityIds = ''
			}else{
				this.formData.showTypeTagIds = ''
			}
            this.$refs["formData"].validate( async (valid) => {
                if(valid){                    
                    this.btnLoading = true;
                    this.$request({
                        url: "/random/discount/edit",
                        method: "POST",
                        data: {
                            ...this.formData,
							startTime: this.formData.datetimerange[0],
							endTime: this.formData.datetimerange[1],
							showTypeTagIds:this.formData.showTypeTagIds ? this.formData.showTypeTagIds.toString() : '',
							activityIds:this.activityIds
							
                        },
                    })
                    .then((res) => {
                        const { state, msg } = res.data;
                        if ( state == 1) {
                            this.$emit('onUpdate');
                            this.close();
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    })
                    .catch(() => {
                        this.$message.error("请求错误");
                    })
                    .finally(() => {
                        this.btnLoading = false;
                    });
                }else{
                    return false;
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>

</style>